export default __webpack_public_path__ + "static/bg-98924a62aa5dd18a32557311badf0ea4.png";